import * as React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Select from 'react-select';

import { ApplicationState } from './../../reducers/Index';
import { createSharedLink } from './../../actions/UserActions';
import { LinkStuff, UserState, FilterState } from '../../interface/MyInterfaces';
import { EarlyCareerReportState } from '../../interface/EarlyCareerReportInterface';

import ReactModal from 'react-modal';

import { Modal } from 'react-bootstrap'

interface SharedLinkFormProps {
    showModal?: any;
    reportType?: any;
    UserState?: UserState;
    FilterState?: FilterState;
    EarlyCareerReportState?: EarlyCareerReportState;
    createSharedLink?(linkStuff);
    handleClose?();
}

interface SharedLinkFormState {
    activeTime?: any;
    timeType?: any;

    hideError?: any;
    expirationDate?: any;
    notes?: any;
}

class SharedLinkForm extends React.Component<SharedLinkFormProps, SharedLinkFormState> {
    constructor(props) {
        super(props);
        this.state = { timeType: "days", hideError: true };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleActiveTimeChange = this.handleActiveTimeChange.bind(this);
        this.handleTimeTypeChange = this.handleTimeTypeChange.bind(this);
        this.handleCopyURL = this.handleCopyURL.bind(this);
        this.handleNotesChange = this.handleNotesChange.bind(this);
        
    }

    handleCopyURL() {
        const el = document.createElement('textarea');
        el.value = this.props.UserState.share_report_link;
        el.setAttribute('readonly', '');
        el.style.position = 'absolute';
        el.style.left = '-9999px';
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
    }

    handleActiveTimeChange(event) {
        this.setState({
            activeTime: event.target.value
        });
    }
    handleNotesChange(event) {
        this.setState({
            notes: event.target.value
        });
    }
    handleTimeTypeChange(event) {
        this.setState({
            timeType: event.value
        });
    }
    handleClose() {

    }
    handleSubmit() {
        if (this.state.activeTime !== undefined && this.state.activeTime !== "" && this.state.activeTime !== 0) {
            var today = new Date();
            var newdate = new Date();

            if (this.state.timeType == "days") {
                newdate.setDate(today.getDate() + parseInt(this.state.activeTime)); 
            } else if (this.state.timeType == "weeks") {
                newdate.setDate(today.getDate() + ( parseInt(this.state.activeTime) * 7 ) ); 
            } else if (this.state.timeType == "months") {
                newdate.setDate(today.getDate() + ( parseInt(this.state.activeTime) * 30 ) ); 
            }
            let expiration_date = newdate.toISOString().slice(0, 10);
            this.setState({
                expirationDate: expiration_date
            });            

            var linkStuff: LinkStuff = {};
            linkStuff.display_id = this.props.UserState.report_display_id;
            linkStuff.expired_date = expiration_date;
            linkStuff.username = this.props.UserState.username;
            linkStuff.report_type = this.props.reportType;


            
            if (linkStuff.report_type == "spending_report") {
                linkStuff.year_type = this.props.FilterState.year_type;
                linkStuff.start_year = this.props.FilterState.start_year;
                linkStuff.end_year = this.props.FilterState.end_year;
                //linkStuff.agg_year = this.props.FilterState.agg_year; //this is for aggregate spending report
                linkStuff.work_study = this.props.FilterState.work_study;
                linkStuff.spending_type = this.props.FilterState.report_type.substring(0,3);
                linkStuff.bench_year = this.props.FilterState.bench_year;
                linkStuff.bench_school = this.props.FilterState.bench_schools;

                linkStuff.agg = this.props.FilterState.aggregate;
                //linkStuff.agg_school = this.props.FilterState.bench_schools;
                linkStuff.negative_payment = this.props.FilterState.negative;
                linkStuff.vintage = this.props.UserState.report_vintage_spending;

                const { submission_month_year: submissionTime } = this.props.UserState.UniversityListSpendingReport.filter(u => u.display_id == this.props.UserState.report_display_id)[0];
                linkStuff.submission_time = submissionTime;
            }
            else if (linkStuff.report_type == "early-career-report") {
                const filterValues = this.props.EarlyCareerReportState.EarlyCareerReportFilterSavedValues;

                linkStuff.ecr_award = filterValues.ecr_award.join(',') == '' ? 'null' : filterValues.ecr_award.join(',');
                linkStuff.gender = filterValues.gender.join(',') == '' ? 'null' : filterValues.gender.join(',');
                linkStuff.suborg = filterValues.suborg.join(',') == '' ? 'null' : filterValues.suborg.join(',');
                linkStuff.funder = filterValues.funder.join(',') == '' ? 'null' : filterValues.funder.join(',');

                linkStuff.no_compare = filterValues.no_compare;
                linkStuff.ecr_award_compare = filterValues.ecr_award_compare;
                linkStuff.gender_compare = filterValues.gender_compare;
            }
          
            //linkStuff.org_name = //agg report

            if (linkStuff.report_type == "new-vendor-report") {
                linkStuff.vintage = this.props.UserState.report_vintage_vendor;
            }

            if (linkStuff.report_type == "impact_finder") {
                linkStuff.vintage = this.props.UserState.report_vintage_impactfinder;
            }

            if (linkStuff.report_type == "employee_report") {
                linkStuff.vintage = this.props.UserState.report_vintage_employee;
            }

            if (linkStuff.report_type == "employee-report") {
                linkStuff.vintage = this.props.UserState.report_vintage_sb_employee;
            }

            if (linkStuff.report_type == "early-career-report") {
                linkStuff.vintage = this.props.UserState.report_vintage_early_career;
            }
          
            linkStuff.university = this.props.UserState.university;


            if (linkStuff.report_type == "congressional-district-detail-report") {
                linkStuff.vintage = this.props.UserState.report_vintage_one_district;
                linkStuff.university = this.props.UserState.report_university_name;
            }

            linkStuff.notes = this.state.notes;
            this.props.createSharedLink(linkStuff);
        }
    }

    render() {
        const options = [{ label: "days", value: "days" }, { label: "weeks", value: "weeks" }, { label: "months", value: "months" }];
        return <ReactModal
            isOpen={this.props.showModal}
            className="ShareModal"
            overlayClassName="ShareOverlay"
            ariaHideApp={false}>
            <button id="close-shared-link" className="btn-primary filterButton closeButton" type="button" aria-label="Close" onClick={this.props.handleClose}>X CLOSE</button>

            <h1>Share Report</h1>
            <form>
                {!this.state.hideError && <label className="filterError">URL active time must be filled</label>}
                <fieldset>
                    <span>Active time</span>
                    <input aria-label="Active Time" value={this.state.activeTime} type="text" className="form-control narrow" name="activeTime"
                        onChange={this.handleActiveTimeChange} />
                    <Select className="filterdropdown" name="timeType" id="time_type"
                        value={{
                            label: this.state.timeType.toString(),
                            value: this.state.timeType
                        }}
                        onChange={this.handleTimeTypeChange}
                        options={options}
                    />
                    <br/><span className=''>Notes</span>
                    <input aria-label="Enter Notes" type="text" className="form-control" id="notes" name="notes" onChange={this.handleNotesChange} value={this.state.notes} />
                </fieldset>
                <button id="create-link" aria-label="Create Report Link" className="btn-primary filterButton" type="button" onClick={this.handleSubmit}>Create Report Link</button>

                <fieldset>
                    <span className=''>URL link</span>
                    <textarea aria-label="Enter URL Link" className="form-control" id="urlLink" name="urlLink" value={this.props.UserState.share_report_link} />
                </fieldset>
                <fieldset>
                    <span className='paddingZero'>Expires on</span>{this.state.expirationDate}
                </fieldset>
                <button aria-label="Copy URL" className="btn-primary filterButton" type="button" onClick={this.handleCopyURL}>Copy URL</button>

            </form>

        </ReactModal>
    }
}

function matchDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            createSharedLink: createSharedLink
        }, dispatch
    )
}

const mapStateToProps = (state: ApplicationState) => ({
    FilterState: state.filterProperties,
    UserState: state.userProperties,
    EarlyCareerReportState: state.earlyCareerReportProperties
});

export default connect(
    mapStateToProps, // Selects which state properties are merged into the component's props
    matchDispatchToProps
)(SharedLinkForm);